import { useEffect } from 'react';

import { Navigation } from '@quizzach/components';
import { Reveal } from '@quizzach/motion';
import { LegalHead, LegalPage, TermsArticle } from '@quizzach/styles';
import { scrollToTop } from '@quizzach/utils';

/*
 * Croatian-only legal document; content mirrors the former static page
 * (app/public/terms-of-use.html), so it stays out of the i18n catalogs.
 */
export const TermsOfUse = () => {
	useEffect(() => {
		scrollToTop();
	}, []);

	return (
		<LegalPage>
			<Navigation />

			<LegalHead>
				<Reveal as='h1'>Opći uvjeti poslovanja</Reveal>
				<Reveal delay={1}>
					<span className='hand'>Datum zadnjeg ažuriranja: 22.10.2026.</span>
				</Reveal>
			</LegalHead>

			<TermsArticle data-id='terms-of-use-container'>
				{/* plain div: Reveal's 12% threshold never fires on a column this tall */}
				<div className='col'>
					<h2>1. Uvod</h2>
					<p>
						Ovaj dokument (zajedno s dokumentima koji su ovdje spomenuti)
						utvrđuje opće uvjete koji reguliraju upotrebu ove mrežne stranice,
						odnosno platforme Quizzach (www.quizzach.com) i kupnju proizvoda
						(kvizova) na njoj (u daljnjem tekstu: Uvjeti).
					</p>
					<p>
						Kupnju kvizova na ovoj mrežnoj stranici provodi naš ovlašteni online
						preprodavatelj Paddle.com. Paddle.com je prodavatelj (Merchant of
						Record) za sve naše narudžbe. Paddle pruža korisničku podršku za sve
						upite vezane uz narudžbe i obrađuje povrate.
					</p>
					<p>
						Our order process is conducted by our online reseller Paddle.com.
						Paddle.com is the Merchant of Record for all our orders. Paddle
						provides all customer service inquiries and handles returns.
					</p>
					<p>
						Pozivamo vas da prije korištenja ovom mrežnom stranicom pozorno
						pročitate uvjete, našu politiku kolačića i našu informacije o obradi
						podataka (u daljnjem tekstu zajedno: Politike zaštite podataka).
					</p>
					<p>
						Kada se koristite ovom mrežnom stranicom ili obavljajte kupnje na
						njoj, primjenjuju se ovi Uvjeti i naše Politike zaštite privatnosti.
						Ako niste suglasni s Uvjetima i Politikom zaštite privatnosti,
						nemojte se koristiti ovom mrežnom stranicom.
					</p>
					<p>
						Ovi se Uvjeti mogu izmijeniti. Vaša je odgovornost da ih redovito
						čitate, jer se uvijek primjenjuju oni Uvjeti koji vrijede u trenutku
						korištenja mrežnom stranicom ili obavljanja kupnje (kako je navedeno
						u nastavku).
					</p>
					<p>
						Ako imate bilo kakvih pitanja u vezi Uvjeta ili Politika zaštite
						privatnosti, možete nam se obratiti putem maila luka@incendio.tech.
					</p>

					<h2>2. Naši podaci</h2>
					<p>
						Ovom mrežnom stranicom upravlja te pruža usluge prodaje kvizova
						trgovačko društvo Incendio d.o.o., sa sjedištem na adresi Vladimira
						Nazora 192, Podgajci Podravski, OIB: 19946433374, koje zastupa Luka
						Dolančić. Društvo je upisano u sudski registar Trgovačkog suda u
						Osijeku, MBS 030296003.
					</p>
					<p>
						Kontakt podaci Društva su: <br />
						Mail: luka@incendio.tech <br />
						Tel: +385 91 792 1228
					</p>

					<h2>3. Vaši podaci i Vaši posjeti ovoj mrežnoj stranici</h2>
					<p>
						Prilikom posjete i/ili korištenja ove mrežne stranice ili kupnje
						proizvoda oglašenih na ovoj mrežnoj stranici (kvizova), obrađuju se
						Vaši osobnih podaci u skladu s Politikama zaštite osobnih podataka
						koje su objavljene i dostupne. Na mrežnim stranicama uvijek su
						dostupne zadnje važeće verzije tih dokumenata te se svaka obrada
						provodi u skladu s tamo dostupnim informacijama.
					</p>

					<h2>4. Registracija korisnika</h2>
					<p>
						Kako bi mogli kupovati na našoj mrežnoj stranici morate se
						registrirati, odnosno otvoriti svoj korisnički račun. Pri
						registraciji potrebno je dati sljedeće podatke:
					</p>
					<ul>
						<li>
							Ime, prezime, mail, privremeni username (kojeg kreiramo temeljem
							Vašeg unesenog maila, ali ga nakon registracije možete izmijeniti)
							i lozinku.
						</li>
					</ul>
					<p>
						Ovi podaci su nam potrebni radi zaštite prava i interesa korisnika.
						Prije svega kako bi mogli utvrditi i provjeriti identitet pojedinaca
						radi registracije i radi ispunjenja prava i obveza prilikom kupnje
						proizvoda (kvizova). Ako se odlučite na registraciju dužni ste dati
						potpune i točne osobne podatke te nas obavijestiti o svakoj promjeni
						registracijskih podataka (izuzev username-a i lozinke) najkasnije u
						roku od 7 dana od nastanka promjene. U slučaju propusta da učinite
						navedeno, odgovarate za svaku štetu koja može nastati kao posljedica
						tog propusta.
					</p>
					<ol type='1'>
						<li>Prihvat ovih Općih uvjeta poslovanja</li>
						<li>Unos kontakt podataka (maila)</li>
						<li>Unos osobnih podataka (ime i prezime)</li>
						<li>Unos lozinke</li>
						<li>
							Potvrda email adrese klikom na adresu iz maila poslanog nakon
							popunjavanja registracijske forme
						</li>
					</ol>
					<p>
						Kontakt podatci, odnosno mail potreban je radi potvrde registracije,
						u slučaju potrebe resetiranja postojeće lozinke i za dostavu drugih
						relevantnih informacija vezanih uz korisnički račun.
					</p>
					<p>
						Bez unosa osobnih podataka koji se traže prilikom registracije,
						uključujući i mail, registracija neće biti moguća.
					</p>
					<p>
						Nakon uspješne registracije, kreira se Vaš jedinstveni korisnički
						račun kojem možete u svakom trenutku pristupiti unosom svoje mail
						adrese i lozinke.
					</p>

					<h2>5. Sadržaj korisničkog profila</h2>
					<p>
						Na Vašem korisničkom profilu dostupan Vam je pregled svih do tada
						izvršenih kupnji i izvršenih transakcija. Također, na profilu ćete u
						svakom trenutku moći pristupiti ranije kupljenim kvizovima. Profil
						možete uređivati u svakom trenutku – izabrati i izmijeniti svoj
						username te urediti profilnu sliku odabirom neke od ponuđenih
						opcija.
					</p>
					<p>
						Incendio zadržava pravo ukidanja i promjene izgleda i sadržaja
						Platforme Quizzach te svih aplikacija/servisa i podstranica koje su
						sastavni dio te platforme, uključujući i stranicu na kojoj je Vaš
						korisnički račun. Također, Incendio zadržava pravo dodavanja novih
						aplikacija/servisa, odnosno funkcionalnosti na platofrmi Quizzach.
						Incendio neće biti odgovoran Korisniku za eventualnu štetu nastalu
						uslijed takvih promjena.
					</p>

					<h2>6. Kupnja kvizova</h2>
					<p>
						Kupnja kvizova moguća je isključivo registriranim korisnicima. Prije
						kupnje potrebno je logirati se na svoj korisnički račun.
					</p>
					<p>
						Za izvršavanje kupnje potrebno je slijediti postupak online kupnje i
						kliknuti na potvrdu plaćanja, nakon čega ćete zaprimiti mail s
						potvrdom izvršene kupnje.
					</p>
					<p>
						Kupljeni kviz bit će vam dostupan odmah nakon uplate, a istom ćete
						moći pristupiti putem linka koji će Vam se odmah prikazati ili kojeg
						možete naći na svom profilu.
					</p>
					<p>
						Na profilu će Vam biti dostupni linkovi i za sve ranije izvršene
						kupnje kojima ćete moći pristupiti u svakom trenutku.
					</p>
					<p>
						Za potrebe ovih Uvjeta, „dostava” se smatra izvršenom čim zaprimite
						mail s potvrdom kupnje ili Vam link postane dostupan u profilu.
					</p>

					<h2>7. Cijena i plaćanje</h2>
					<p>
						Cijena proizvoda (kviza) bit će ona koja je u trenutku kupnje
						navedena na našoj mrežnoj stranici, osim u slučaju očite pogreške u
						kojem slučaju ćemo Vas kontaktirati kako bi Vas obavijestili o
						navedenom. U navedenoj sitauciji imat ćete mogućnost prihvata kupnje
						po ispravnoj cijeni ili otkazivanja kupnje. Ako ne uspijemo stupiti
						s Vama u kontakt, Vaša narudžba će automatski biti otkazana o čemu
						ćete biti obaviješteni.
					</p>
					<p>Cijene na mrežnoj stranici uključuju PDV.</p>
					<p>
						Cijene se mogu promijeniti u bilo kojem trenutku, ali promjene neće
						utjecati na već potvrđene kupnje.
					</p>
					<p>
						Nakon što ste odabrali sve artikle koje želite kupiti, isti će biti
						dodani u Vašu košaricu. Sljedeći je korak obrada narudžbe i
						izvršavanje uplate. U tu je svrhu potrebno slijediti korake postupka
						kupnje i navesti ili potvrditi tražene podatke u svakom koraku.
						Plaćanje se izvršava u Paddleovoj naplatnoj formi, a dostupni načini
						plaćanja (npr. platne kartice i PayPal) prikazuju se u toj formi.
					</p>
					<p>
						Kartice podložne provjeri i odobrenju od strane subjekta koji ju je
						izdao. Ako subjekt ne odobrava isplatu, nećemo biti odgovorni za
						bilo kakvo kašnjenje ili neuspjeh dostave i nećemo biti u mogućnosti
						zaključiti bilo kakav ugovor s vama.
					</p>

					<h2>8. Nedostaci proizvoda (neusklađenost)</h2>
					<p>
						U slučaju da kupljeni proizvod (kviz) bitno odstupa od opisane
						kvalitete I ne ispunjava opisanu namjenu za koju se proizvod
						uobičajeno koristi, ostvarujete pravo zahtjevati otklanjanje
						nedostataka ili razmjerno sniženje cijene.
					</p>
					<p>
						U slučaju zaprimljenog zahtjeva dužni smo o osnovanosti istog
						odlučiti najkasnije u roku od 15 dana te Vas u istom roku
						obavijestiti o tome hoće li Vam zahtjevu biti udovoljeno ili ne. U
						slučaju odbijanja zahtjeva potrebno je navesti obrazloženje.
					</p>
					<p>
						Ako se ocjieni da je zahtjev osnovan, a zatražili ste otklanjanje
						nedostataka isti će biti otklonjeni u razumnom roku, uzimajući u
						obzir prirodu nedostatka. Društvo će Vas prilikom obavještavanja o
						osnovanosti zahtjeva obavijestiti I o tome koji je očekivani rok
						otklanjanja nedostatka. Ako je zahtjev osnovan, a zatraženo je
						razmjerno snižavanje cijene povrat će se izvršiti u skladu s
						odredbama iz točke 8.1..
					</p>
					<p>
						U slučaju da je otklananje nedostatka nemoguće , dužni smo Vas o
						tome obavijestiti, kao i o razlozim nemogućnosti otklanjanja
						nedostataka.
					</p>
					<p>
						Ako otklanjanje nije moguće ili nedostatak ne otklonimo u razumnom
						roku, uvažavajući prirodu nedostatka, a riječ je o značajnom
						nedostatku , ostvarujete pravo na raskid ugovora (točka 8.1. ovih
						Uvjeta).
					</p>
					<p>
						Obavijest o utvrđenom nedostatku, kao i zahtjeve za ostvarivanjem
						svojih prava vezana uz utvrđeni nedostatak možete osvariti slanjem
						obavijesti i/ili podnošenjem zahtjeva za ostvarivanjem nekog od
						navedenih prava slanjem maila na luka@incendio.tech.
					</p>

					<h3>8.1. Učinci raskida Ugovora</h3>
					<p>
						U slučaju podnošenja zahtjeva za snižavanjem cijene ili za raskidom
						Ugovora dužni smo Vam vratiti cijenu koju ste platiti za kupljeni
						proizvod, odnosno iznos za koji je cijena razmjerno snižena i to
						najkasnije u roku od 14 dana od dana zaprimanja Vašeg osnovanog
						zahtjeva za sniženjem cijene ili raskidom ugovora. Povrat će
						izvršiti Paddle, istim sredstvom plaćanja koje ste upotrijebili
						prilikom kupnje našeg proizvoda.
					</p>
					<p>
						Nakon raskida ugovora više nećete moći pristupiti kvizu te će kviz
						(link za pristup) biti izbrisan iz Vašeg profila.
					</p>

					<h2 id='refund-policy'>
						9. Politika povrata i pravo na jednostrani raskid
					</h2>
					<p>
						Pravo na jednostrani raskid ugovora možete ostvariti bez navođenja
						razloga za raskid u roku od 14 dana od dana sklapanja ugovora
						(kupnje kviza). Ovo pravo možete ostvariti popunjavanjem obrasca
						koji Vam je dostupan na našem web-u ili putem bilo koje druge izjave
						koju nam dostavite, a iz koje je jasno vidljivo kako želite
						ostvariti svoje pravo na raskid. Izjavu o raskidu ugvora (popunjeni
						obrazac ili svoju izjavu kojom zahtijevate raskid) nam možete
						poslati na mail luka@incendio.tech. Raskid možete izjaviti i putem
						funkcije za jednostrani raskid („Request withdrawal”) u Paddleovom
						korisničkom portalu, kojem pristupate putem poveznice „Manage
						transaction” u e-mailu s potvrdom kupnje ili putem stranice
						https://paddle.net. Izjavu morate poslati prije isteka roka od 14
						dana.
					</p>
					<p>
						U slučaju da izjavite raskid ugovora dužni smo Vam vratiti cijenu
						koju ste platiti za kupljeni proizvod to najkasnije u roku od 14
						dana od dana primitka izjave da raskidate ugovor, a Vi nećete moći
						pristupiti kupljenom kvizu putem linka koji Vam je poslan mailom te
						će kviz (link za pristup kvizu) biti izbrisan iz Vašeg profila.
						Povrat uplaćenih sredstava izvršit će Paddle, istim sredstvom
						plaćanja koje ste upotrijebili prilikom kupnje našeg proizvoda.
					</p>
					<p>
						<b>
							Napominjemo kako pravo na jednostrani raskid ostvarujete samo ako
							niste preuzeli (pokrenuli) kviz putem linka koji Vam je dostupan u
							mailu i Vašem profilu. Trenutkom preuzimanja (pokretanja) kviza
							gubite pravo na jednostrani raskid ugovora.
						</b>
					</p>

					<h2>10. Pravo na podnošenje prigovora</h2>
					<p>
						Svoje nezadovoljstvo u odnosu na kupljeni proizvod možete izjaviti
						podnošenjem prigovora putem mail adrese luka@incendio.tech ili
						slanjem istog na poslovnu adresu Društva.
					</p>
					<p>
						Na zaprimljeni prigovor dužni smo Vam se očitovati najkasnije u roku
						od 15 dana od dana zaprimanja istog.
					</p>

					<h2>11. Poveznice s naše mrežne stranice</h2>
					<p>
						Ako naša mrežna stranica sadrži poveznice na druge mrežne stranice i
						materijale trećih strana, te poveznice služe samo u informativne
						svrhe i nemamo nikakvu kontrolu nad sadržajem tih mrežnih stranica
						ili materijala. Prema tome ne preuzimamo nikakvu odgovornost za bilo
						kakav gubitak ili štetu proizašlu iz njihove uporabe.
					</p>

					<h2>12. Pisana komunikacija</h2>
					<p>
						Korištenjem ovom mrežnom stranicom pristajete na to da većina
						komunikacije s nama bude obavljena elektroničkim putem. Mi ćemo vam
						se obratiti mailom ili ćemo vam pružiti informacije slanjem
						obavijesti putem ove mrežne stranice. Za svrhe Ugovora, suglasni ste
						s time da se koristite ovim elektroničkim sredstvom komunikacije i
						prihvaćate da su svi ugovori, obavijesti, informacije i druge
						komunikacije koje vam šaljemo elektroničkim putem u skladu sa
						zakonskim zahtjevima o slanju istih u pisanom obliku. Ovaj uvjet
						neće utjecati na vaša zakonska prava.
					</p>

					<h2>13. Naše pravo na izmjenu ovih uvjeta</h2>
					<p>
						Imamo pravo pregledati i izmijeniti ove Uvjete u bilo koje vrijeme.
						Izmjene uvjeta stpaju na snagu datumom njihove objave. Vi
						podliježete pravilima i Uvjetima koji su na snazi u trenutku u kojem
						se koristite ovom mrežnom stranicom ili obavite kupnju.
					</p>

					<p className='fine'>IBAN: HR6824020061500156960</p>
					<p className='fine'>
						Poslovna banka: Erste&amp;Steiermärkische Bank d.d.
					</p>
					<p className='fine'>
						Temeljni kapital: EUR 2.500 (uplaćen u cijelosti)
					</p>
				</div>
			</TermsArticle>
		</LegalPage>
	);
};
